import React, {Fragment, useEffect, PropsWithChildren} from "react";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {IHOCUserManagementController} from "views/components/hoc/hoc_user_management/hoc_user_management.controller";
import {Bindings} from "data/constants/bindings";
import {ModalUserManagement} from "views/components/modals/modal_user_management/modal_user_management.component";
import {useIdleTimer} from "react-idle-timer";
import {noop} from "lodash";

const DAY_MINUTES = 60 * 24;
const timeoutMinutes = Number(
	new URLSearchParams(window.location.search).get("timeoutMinutes") || DAY_MINUTES
);

export const HOCUserManagement: React.FC<PropsWithChildren> = observer(({children}) => {
	const controller = useViewController<IHOCUserManagementController>(
		Bindings.HOCUserManagementController
	);

	const timeout = 1000 * 60 * timeoutMinutes;
	let timeoutTimer: ReturnType<typeof setTimeout> = setTimeout(noop, 0);

	/**
	 * Using the useIdleTimer hook to detect user inactivity and run callbacks accordingly
	 */
	useIdleTimer({
		onAction: () => {
			clearTimeout(timeoutTimer);
			if (controller.isUserApproved) {
				const time = localStorage.getItem("time");
				const dffTime = Date.now() - Number(time);
				/**
				 * If the stored time is not null and the difference in time is greater than the timeout duration
				 */
				if (time && dffTime > timeout) {
					localStorage.removeItem("time");
					controller.logoutUser();
					return;
				}
				localStorage.setItem("time", Date.now().toString());
			}

			/**
			 * Setting the timeout timer to log out the user after the timeout duration if there are any other actions
			 */
			timeoutTimer = setTimeout(controller.logoutUser, timeout);
		},
		onActive: () => {
			localStorage.removeItem("time");
		},
		timeout,
	});

	useEffect(() => {
		clearTimeout(timeoutTimer);
	}, [timeoutTimer]);

	if (!controller.isUserApproved) {
		return <ModalUserManagement />;
	}

	return <Fragment>{children}</Fragment>;
});
